/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { Grid } from '@mui/material';
import { withStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { categories, Category } from '../common/Categories';
import { isRoleExists, sendRequestAndReceiveResponse } from '../common/common';
import { FileNameforInstrumentConstantsEndpoint, getInstrumentConstantsEndPoint, getPresignMultipleInstrumentConstants, partNumberSearchEndpoint } from '../common/constants';
import { loadFromLocalStorage } from '../common/localStorage';
import { actionCreators } from '../store/ViewInstrumentConstants';
import Export from './Export';
import FileNameSearch from './FileNameSearch';
import PartNumberSearch from './PartNumberSearch';
import ProductClassification from './ProductClassification';
import UploadConstants from './UploadConstants';

const styles = () => ({
    selectInput: {
        backgroundColor: '#fff',
        borderRadius: 0,
        boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.2)',
        '& em': {
            fontSize: 14,
            fontStyle: 'normal'
        }
    },
    dropdown: {
        fontSize: 14,
        fontStyle: 'normal',
        marginLeft: 10
    }
});

const ProductFamily = 'selectedFamily';
const ProductName = 'selectedProductName';
const ProductModel = 'selectedProductModel';

// Removed json2csv dependency; using a lightweight CSV builder

interface Props {
    selectedFamily: any
    selectedProductName: any
    selectedProductModel: any
    families: any
    productModels: any
    productNames: any
    fileName: any
    partNumber: any
    modelname: any
    id: any
    IsPartConstant: boolean
    isSearchstarted: boolean
    isInstrumentConstantsLoading: any
    instrumentConstantsData: any
    StopLoading: Function,
    UpdatePartNumber: Function,
    UpdateProductFamilies: Function
    UpdateSelectedFamily: Function,
    UpdateSelectedProductName: Function
    UpdateSelectedProductModel: Function
    LoadInstrumentConstants: Function
    LoadConstntsforNumber: Function
    UpdateFileName: Function
    UpdatepartNumber: Function
    UpdatepartNumbersearchresults: Function
    UpdatefileNamesearchresults: Function
    FilterNames: Function
    FilterModels: Function
    UpdateModelName: Function
    UpdateExportResults: Function
    UpdateModelNameForPartNumber: Function
    ClearInstrumentConstantsList: Function
    ClearViewConstantsData: Function
    ClearInstrumentConstantsExportList: Function
    Updatesearchstatus: Function
}

interface State {
    currentUrl: any,
    selectedfilterValue: any
}

class InstrumentConstants extends React.Component<Props, State>{

    async componentDidMount() {
        this.props.ClearViewConstantsData();
    }
    isExportingtoCSV = false;
    handleFileNameSearch = async (data: any) => {
        this.props.UpdatefileNamesearchresults(data);
    };
    LoadInstrumentConstants = (data: any) => {
        this.props.LoadInstrumentConstants(data);
    };
    UpdateFileName = (data: any) => {
        this.props.UpdateFileName(data);
    };
    UpdatefileNamesearchresults = (data: any) => {
        this.props.UpdatefileNamesearchresults(data);
    };
    StopLoading = () => {
        this.props.StopLoading();
    };
    ClearAll = () => {
        this.props.ClearInstrumentConstantsList();
    };
    handleClassificationChange = (event: any) => {
        if (event.target.value !== '') {
            switch (event.target.name) {
                case ProductFamily:
                    this.props.UpdateSelectedFamily([event.target.value]);
                    this.props.FilterNames(this.props.families, [event.target.value]);
                    break;
                case ProductName:
                    this.props.UpdateSelectedProductName([event.target.value]);
                    this.props.FilterModels(this.props.productNames, [event.target.value]);
                    break;
                case ProductModel:
                    this.props.UpdateSelectedProductModel([event.target.value]);
                    this.props.UpdateModelName(this.props.productModels, [event.target.value]);
                    break;
            }
        }
    };

    handlePartNumberSearch = async (instrumentconstants: any, IsPartConstant: boolean) => {
        await this.props.UpdatepartNumbersearchresults(instrumentconstants, true);
    };

    handleICDownloads = async () => {
        const urls = await sendRequestAndReceiveResponse(JSON.stringify({ 'ModelId': 391 }), getPresignMultipleInstrumentConstants);
        const count = urls.instrumentConstantPresignedURLList.length;
        const pageSize = 250;
        const numberOfPages = Math.ceil(count / 250);
        let initialPage = 0;
        let pageCount = 250;

        for (let i = 0; i < numberOfPages; i++) {
            for (let j = initialPage; j < pageCount; j++) {
                window.open(urls.instrumentConstantPresignedURLList[j].presignedURL);
            }
            initialPage = initialPage + pageSize;
            pageCount = i * pageSize;
        }
    };

    UpdateProductFamilies = (data: any) => {
        this.props.UpdateProductFamilies(data);
    };
    UpdatePartNumber = (data: any) => {
        this.props.UpdatePartNumber(data);
    };
    LoadPartNumber = (data: any) => {
        this.props.LoadConstntsforNumber(data);
    };
    Updatesearchstatus = (data: any) => {
        this.props.Updatesearchstatus(data);
    };
    Row = (datas: { row: any }) => {
        const { row } = datas;
        return (
            <React.Fragment>
                {!this.props.IsPartConstant &&
                    <TableRow>
                        <TableCell />
                        <TableCell className="icText"> {row.fileName} </TableCell>
                        <TableCell className="icText">{row.displayName}</TableCell>
                    </TableRow>
                }
                {this.props.IsPartConstant &&
                    <TableRow>
                        <TableCell />
                        <TableCell className="icText" align="center"> {row.fileName} </TableCell>
                    </TableRow>
                }
            </React.Fragment>
        );
    };
    handleRedirections = () => {
        if (this.props.selectedProductModel != null && this.props.selectedProductModel !== undefined) {
            this.props.UpdateSelectedProductModel(this.props.selectedProductModel);
        }
        else if (this.props.selectedProductName != null && this.props.selectedProductName !== undefined) {
            this.props.UpdateSelectedProductName(this.props.selectedProductName);
        }
        else if (this.props.selectedFamily != null && this.props.selectedFamily !== undefined) {
            this.props.UpdateSelectedFamily(this.props.selectedFamily);
        }
    };
    exportList: Array<object> = [{ id: 0, name: 'CSV' }];
    handleExport = async (exportType: any) => {
        this.exportCSV();
        this.props.ClearInstrumentConstantsExportList();
    };
    async exportCSV() {
        if (this.isExportingtoCSV === false) {
            this.isExportingtoCSV = true;
            if (this.props.fileName !== undefined) {
                const token: string = loadFromLocalStorage('AuthToken');
                const encodedToken = 'Bearer ' + token;
                const headerDict: any =
                {
                    'Authorization': encodedToken,
                    'Content-Type': 'application/json'
                };
                const endpoint = FileNameforInstrumentConstantsEndpoint;
                fetch(endpoint,
                    {
                        headers: new Headers(headerDict),
                        body: JSON.stringify({
                            'fileName': this.props.fileName
                        }),
                        method: 'POST'
                    })
                    .then(async (response: any) => {
                        const data = await response.json();
                        await this.props.UpdateExportResults(data);
                    });
            }
            else if (this.props.partNumber !== undefined) {
                const token: string = loadFromLocalStorage('AuthToken');
                const encodedToken = 'Bearer ' + token;
                const headerDict: any = {
                    'Authorization': encodedToken,
                    'Content-Type': 'application/json'
                };
                const endpoint = partNumberSearchEndpoint;
                fetch(endpoint, {
                    headers: new Headers(headerDict),
                    body: JSON.stringify({
                        'PartNumber': this.props.partNumber
                    }),
                    method: 'POST'
                })
                    .then(async (response: any) => {
                        const data = await response.json();
                        await this.props.UpdateExportResults(data);
                    });
            }
            else {
                const data = await sendRequestAndReceiveResponse(
                    JSON.stringify({
                        ClassificationId: this.props.selectedProductModel,
                        ClassificationType: 'productmodel',
                    }),
                    getInstrumentConstantsEndPoint
                );
                await this.props.UpdateExportResults(data);
            }
            const data = this.props.instrumentConstantsData;
            const fields = this.props.IsPartConstant === true ?
                [{ label: 'File Name', value: 'fileName' }] :
                [{ label: 'File Name', value: 'fileName' }, { label: 'Product Model', value: 'displayName' }];
            const fileName = this.props.IsPartConstant === true ? 'Part Constants' : 'Instrument Constants';
            const escapeCell = (cell: any) => {
                const s = cell == null ? '' : String(cell);
                const needsQuotes = /[",\n]/.test(s);
                const escaped = s.replace(/"/g, '""');
                return needsQuotes ? `"${escaped}"` : escaped;
            };
            if (data !== undefined && Array.isArray(data) && data.length > 0) {
                const header = fields.map(f => escapeCell(f.label)).join(',');
                const body = data.map((row: any) => fields.map(f => escapeCell(row[f.value])).join(',')).join('\n');
                const csv = `${header}\n${body}`;
                const hiddenElement = document.createElement('a');
                const csvData = new Blob([csv], { type: 'text/csv' });
                const csvUrl = URL.createObjectURL(csvData);
                hiddenElement.href = csvUrl;
                hiddenElement.target = '_blank';
                hiddenElement.download = `${fileName}.csv`;
                hiddenElement.click();
                this.isExportingtoCSV = false;
            }
            else {
                this.isExportingtoCSV = false;
            }
        }
        else {
            alert('Job is already Running!');
        }
    };
    getTotalCountOnExport = () => {
        console.log('Export');
    };
    render() {
        const selectedCategory: Category | undefined = categories.find(
            (category: Category) => {
                return category.id === 18;
            }
        );

        return (
            <Grid>
                <Grid container justifyContent="space-between">
                    <FileNameSearch
                        handleFileNameSearch={this.handleFileNameSearch}
                        LoadConstants={this.LoadInstrumentConstants}
                        UpdateFileName={this.UpdateFileName}
                        StopLoading={this.StopLoading}
                        isLoading={this.props.isInstrumentConstantsLoading}
                        fileName={this.props.fileName}
                        ClearAll={this.ClearAll}
                        Updatesearchstatus={this.Updatesearchstatus} />
                    or
                    <ProductClassification families={this.props.families} selectedFamily={this.props.selectedFamily} selectedProductName={this.props.selectedProductName}
                        selectedProductModel={this.props.selectedProductModel}
                        productModels={this.props.productModels} productNames={this.props.productNames}
                        handleManualClassificationChange={this.handleClassificationChange} isLoading={this.props.isInstrumentConstantsLoading}
                        UpdateProductFamilies={this.UpdateProductFamilies} />
                    <div>
                        {isRoleExists(4) && <UploadConstants handleRedirection={this.handleRedirections} />}
                    </div>
                </Grid>
                <div className="divheight" />
                <Grid container justifyContent="space-between">
                    <div>
                        <PartNumberSearch handlePartNumberSearch={this.handlePartNumberSearch} LoadPartNumber={this.LoadPartNumber}
                            UpdatepartNumber={this.UpdatePartNumber} StopLoading={this.StopLoading} isLoading={this.props.isInstrumentConstantsLoading}
                            partNumber={this.props.partNumber} ClearAll={this.ClearAll} Updatesearchstatus={this.Updatesearchstatus} />
                    </div>
                    <div>
                        <Export
                            selectedColumns=""
                            isDisabled={!((this.props.instrumentConstantsData === undefined || this.props.instrumentConstantsData == null ||
                                this.props.instrumentConstantsData.length === 0 || this.props.instrumentConstantsData.status === 404))}
                            exportList={this.exportList}
                            handleExport={this.handleExport}
                            totalCount=""
                            getTotalCountOnExport={this.getTotalCountOnExport}
                            isSearchApplied={false}
                            selectTitle={`Export`} />
                    </div>
                </Grid>
                {/*<Grid container className="downloadEdit font14">*/}
                {/*    <Grid item xs={11}></Grid>*/}
                {/*    <Grid item xs={1}>*/}
                {/*        <Grid container>*/}
                {/*            <Grid item xs={9}> </Grid>*/}
                {/*            <Grid item xs={3}>*/}
                {/*                {*/}
                {/*                    <div>*/}
                {/*                        <FileDownloadOutlinedIcon id="ic-download-button" onClick={this.handleICDownloads}*/}
                {/*                            style={{ cursor: "pointer", fontSize: "1.8rem" }} />*/}
                {/*                    </div>*/}
                {/*                }*/}
                {/*            </Grid>*/}
                {/*        </Grid>*/}
                {/*    </Grid>*/}
                {/*</Grid>*/}
                <div className="divheight" />
                {!this.props.IsPartConstant &&
                    <Grid className="viewInstrumentConstants">
                        <TableContainer component={Paper}>
                            <Table aria-label="collapsible table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell width="5%" />
                                        <TableCell width="45%" className="ictableheaderText" style={{ fontWeight: 'bold' }}>
                                            Constant File Name
                                        </TableCell>
                                        <TableCell width="45%" className="ictableheaderText" style={{ fontWeight: 'bold' }}>
                                            Product Model
                                        </TableCell>
                                        <TableCell width="5%" />
                                    </TableRow>
                                </TableHead>
                                {this.props.instrumentConstantsData !== undefined && this.props.instrumentConstantsData.length > 0 && this.props.instrumentConstantsData.length <= 50 ?
                                    <TableBody>
                                        {this.props.instrumentConstantsData.map((row: any) => (
                                            <this.Row key={row.DisplayName} row={row} />))}
                                    </TableBody> :
                                    this.props.isSearchstarted ?
                                        <TableBody>
                                            <TableRow>
                                                <TableCell id="noicrecords" colSpan={12} align='center' className='no-records'>Searching...</TableCell>
                                            </TableRow>
                                        </TableBody> :
                                        this.props.instrumentConstantsData === undefined ?
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell id="noicrecords" colSpan={12} align='center' className='no-records'>{this.props.instrumentConstantsData}Apply filter or enter a filename or a service part</TableCell>
                                                </TableRow>
                                            </TableBody> :
                                            this.props.instrumentConstantsData.length > 50 ?
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell id="noicrecords" colSpan={12} align='center' className='no-records' style={{ fontWeight: "bold" }}>There are more than 50 constant files. Please export to view the entire results.</TableCell>
                                                    </TableRow>
                                                </TableBody> :
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell id="noicrecords" colSpan={12} align='center' className='no-records'>No constants found</TableCell>
                                                    </TableRow>
                                                </TableBody>

                                }
                            </Table>
                        </TableContainer>

                    </Grid>
                }
                {this.props.IsPartConstant &&
                    <Grid className="viewInstrumentConstants">
                        <TableContainer component={Paper}>
                            <Table aria-label="collapsible table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell width="5%" />
                                        <TableCell width="45%" className="ltgText" align="center" style={{ fontWeight: 'bold' }}>
                                            Constant File Name
                                        </TableCell>
                                        <TableCell width="5%" />
                                    </TableRow>
                                </TableHead>
                                {this.props.instrumentConstantsData !== undefined && this.props.instrumentConstantsData.length > 0 && this.props.instrumentConstantsData.length <= 50 ?
                                    <TableBody>
                                        {this.props.instrumentConstantsData.map((row: any) => (
                                            <this.Row key={row.DisplayName} row={row} />))}
                                    </TableBody> :
                                    this.props.isSearchstarted ?
                                        <TableBody>
                                            <TableRow>
                                                <TableCell id="noicrecords" colSpan={12} align='center' className='no-records'>Searching...</TableCell>
                                            </TableRow>
                                        </TableBody> :
                                        this.props.instrumentConstantsData === undefined ?
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell id="noicrecords" colSpan={12} align='center' className='no-records' style={{ fontWeight: 'bold' }}>{this.props.instrumentConstantsData}Apply filter or enter a filename or service part</TableCell>
                                                </TableRow>
                                            </TableBody> :
                                            this.props.instrumentConstantsData.length > 50 ?
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell id="noicrecords" colSpan={12} align='center' className='no-records' style={{ fontWeight: "bold" }}>There are more than 50 constant files. Please export to view the entire results.</TableCell>
                                                    </TableRow>
                                                </TableBody> :
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell id="noicrecords" colSpan={12} align='center' className='no-records'>No constants found</TableCell>
                                                    </TableRow>
                                                </TableBody>
                                }
                            </Table>
                        </TableContainer>
                    </Grid>
                }
            </Grid>
        );
    }
}

const mapStateToProps = (state: any) => ({
    state: state.instrumentConstants,
    data: state.instrumentConstants.data,
    id: state.instrumentConstants.id,
    instrumentConstantsData: state.instrumentConstants.instrumentConstantsData,
    isInstrumentConstantsLoading: state.instrumentConstants.isInstrumentConstantsLoading,
    IsPartConstant: state.instrumentConstants.IsPartConstant,
    isSearchstarted: state.instrumentConstants.isSearchstarted,
    selectedFamily: state.instrumentConstants.selectedFamily,
    selectedProductName: state.instrumentConstants.selectedProductName,
    selectedProductModel: state.instrumentConstants.selectedProductModel,
    fileName: state.instrumentConstants.fileName,
    productModels: state.instrumentConstants.productModels,
    productNames: state.instrumentConstants.productNames,
    partNumber: state.instrumentConstants.partNumber,
    modelname: state.instrumentConstants.modelname,
    families: state.instrumentConstants.families,
});

const mapDispatchtoProps = (dispatch: any) =>
    bindActionCreators(actionCreators, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchtoProps
)((withStyles(styles)(InstrumentConstants)));
